export default function RunningText() {
    const items = [
        "श्री बालाजी मसाले — मध्य प्रदेश के 15+ जिलों में विस्तार",
        "शुद्ध मसाले • उत्तम गुणवत्ता • वर्षों का विश्वास",
        "FSSAI प्रमाणित | 2001 से गुणवत्ता की पहचान",
    ];

    return (
        <div className="w-full overflow-hidden bg-[#7a0c18] py-3">
            <div className="marquee-track">
                {/* ORIGINAL ITEMS */}
                {items.map((text, index) => (
                    <div className="marquee-item" key={index}>
                        <img
                            src="/images/About/logo.jpg"
                            alt="श्री बालाजी मसाले"
                            className="h-8 w-auto"
                        />
                        <span>{text}</span>
                    </div>
                ))}

                {/* DUPLICATE ITEMS (infinite smooth loop के लिए) */}
                {items.map((text, index) => (
                    <div className="marquee-item" key={`dup-${index}`}>
                        <img
                            src="/images/About/logo.jpg"
                            alt="श्री बालाजी मसाले"
                            className="h-8 w-auto"
                        />
                        <span>{text}</span>
                    </div>
                ))}
            </div>

            <style>
                {`
          .marquee-track {
            display: flex;
            width: max-content;
            animation: marquee 20s linear infinite;
          }

          .marquee-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding-right: 50px;
            color: white;
            font-size: 1.1rem;
            font-weight: 600;
            white-space: nowrap;
          }

          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
            </style>
        </div>
    );
}
